import { Box, Button, Grid } from "@mui/material";
import { PropTypes } from "prop-types";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { identifiersData, inputData, namesData } from "@/data";
import { StyledTextField } from "@/styles";

const DynamicXmlFields = ({ fields, setFields, setValue }) => {
    const { t } = useTranslation();

    const {
        labels: { key: keyInputLabel, value: valueInputLabel },
        names: { key: keyInputName, value: valueInputName, xmlFields: xmlFieldsInputName },
        types: { text: textInputType },
    } = inputData;

    const { addField: addFieldButtonName, remove: removeButtonName } = namesData.buttons;

    const { button: buttonId } = identifiersData.ids;

    const addFieldHandler = () => {
        setFields([
            ...fields,
            {
                key: "",
                value: "",
            },
        ]);
    };

    const removeFieldHandler = (index) => {
        const clonedFields = [...fields];

        clonedFields.splice(index, 1);

        setFields(clonedFields);
    };

    const changeFieldInputValueHandler = (index, name, value) => {
        const clonedFields = [...fields];

        clonedFields[index][name] = value;

        setFields(clonedFields);
    };

    useEffect(() => {
        setValue(
            xmlFieldsInputName,
            fields.reduce((acc, curr) => {
                if (curr.key.trim() !== "" && curr.value.trim() !== "") acc[curr.key] = curr.value;

                return acc;
            }, {}),
        );
    }, [fields, xmlFieldsInputName, setValue]);

    return (
        <>
            <Grid
                spacing={2}
                sx={{
                    mt: 2,
                    overflow: "auto",
                }}
                container
            >
                {fields.map(({ key, value }, index) => (
                    <Grid key={index} spacing={2} container>
                        <Grid size={{ xs: 5 }}>
                            <StyledTextField
                                name={keyInputName}
                                placeholder={t(`labels.${keyInputLabel}`)}
                                type={textInputType}
                                value={key}
                                fullWidth
                                onChange={(e) => changeFieldInputValueHandler(index, keyInputName, e.target.value)}
                            />
                        </Grid>
                        <Grid size={{ xs: 5 }}>
                            <StyledTextField
                                name={valueInputName}
                                placeholder={t(`labels.${valueInputLabel}`)}
                                type={textInputType}
                                value={value}
                                fullWidth
                                onChange={(e) => changeFieldInputValueHandler(index, valueInputName, e.target.value)}
                            />
                        </Grid>
                        <Grid size={{ xs: 2 }}>
                            <Button
                                color="error"
                                id={`${removeButtonName}_${buttonId}`}
                                size="large"
                                variant="outlined"
                                onClick={() => removeFieldHandler(index)}
                            >
                                {t("actions.remove")}
                            </Button>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
            <Box
                sx={{
                    mt: 2,
                }}
            >
                <Button
                    color="success"
                    id={`${addFieldButtonName}_${buttonId}`}
                    size="large"
                    variant="outlined"
                    onClick={addFieldHandler}
                >
                    {t("actions.addField")}
                </Button>
            </Box>
        </>
    );
};

export default DynamicXmlFields;

DynamicXmlFields.propTypes = {
    fields: PropTypes.array,
    setFields: PropTypes.func,
    setValue: PropTypes.func,
};
